export default __webpack_public_path__ + "static/media/screen.ae9ce6a6.png";